import { Link } from 'react-router-dom';
import { allArticles } from '@/mocks/articles';
import Navbar from '@/components/Navbar';
import FooterSection from '@/pages/home/components/FooterSection';

const siteUrl = 'https://basetaosheet.mom';

const collectionJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  name: 'BaseTao Spreadsheet Shopping Guide',
  description: 'Complete collection of expert BaseTao Spreadsheet guides, reviews, tutorials, and tips to master your shopping experience.',
  url: `${siteUrl}/guides`,
  hasPart: allArticles.map((article, index) => ({
    '@type': 'Article',
    headline: article.title,
    description: article.metaDescription,
    url: `${siteUrl}/article/${article.slug}`,
    datePublished: article.publishedDate,
    position: index + 1,
  })),
};

const breadcrumbJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Home',
      item: `${siteUrl}/`,
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: 'Shopping Guide',
      item: `${siteUrl}/guides`,
    },
  ],
};

export default function GuidesPage() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(collectionJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbJsonLd) }}
      />
      <Navbar />
      <main>
        <section className="relative w-full py-16 md:py-24 overflow-hidden bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6 text-center pt-12">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wide mb-4">
              Resources
            </span>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 mb-4">
              BaseTao Spreadsheet Shopping Guide
            </h1>
            <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
              Explore our complete collection of expert guides, reviews, tutorials, and tips to master your BaseTao shopping experience.
            </p>
          </div>
        </section>

        <section className="w-full py-10 md:py-16 bg-background-50">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {allArticles.map((article) => (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className="group block rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 overflow-hidden transition-all duration-300 cursor-pointer"
                >
                  <div className="aspect-[3/2] overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      title={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-5">
                    <div className="flex items-center gap-3 mb-2">
                      <span className="px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                        {article.tag}
                      </span>
                      <span className="text-foreground-500 text-xs">{article.publishedDate}</span>
                    </div>
                    <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 mb-2 leading-snug line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="text-foreground-600 text-sm leading-relaxed line-clamp-2">
                      {article.metaDescription}
                    </p>
                    <div className="mt-4 flex items-center gap-1 text-primary-600 text-sm font-medium">
                      Read Article
                      <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center group-hover:translate-x-1 transition-transform duration-200"></i>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
      <FooterSection />
    </>
  );
}